import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router';
import FadeIn from 'react-fade-in';
import { lng } from './js/language.js';

function Home() {
    const [currentLangObj, setCurrentLangObj] = useState(lng[localStorage.getItem('currentLang') || 'bg']);

    function handleCheckLang() {
        setCurrentLangObj(lng[localStorage.getItem('currentLang') || 'bg']);
    }

    useEffect(() => {
        window.addEventListener('click', handleCheckLang);
        return () => {
            window.removeEventListener('click', handleCheckLang);
        };
    }, []);

    return (
        <section className="hero">
            <Helmet>
                <title>Векота - софтуер, сайтове, онлайн магазини, мобилни приложения</title>
                <meta property="og:description" content="Векота - изработка на софтуер, сайтове, онлайн магазини, мобилни приложения" />
            </Helmet>
            <div className="container">
                <div className="row">
                    <div className="col-12 ">
                        <div className="swiper-container hero-slider">
                            <div className="">
                                <div className="swiper-slide slide-content d-flex align-items-center">
                                    <div className="single-slide">
                                        <h1 className="head-1">
                                            {currentLangObj.head1}
                                        </h1>
                                        <h2 className="head-2">
                                            {currentLangObj.head2}
                                        </h2>
                                        <h2 className="quickly">
                                            {currentLangObj.quickly}
                                        </h2>
                                        <p className="content-1">
                                            <elem dangerouslySetInnerHTML={{ __html: currentLangObj.content1 }} />
                                        </p>
                                        <div className="center-btn">
                                            <FadeIn
                                                delay = {300}
                                                transitionDuration = {300}
                                            >
                                                <div>
                                                    <Link to="#prices" className="btn btn-primary offers">
                                                        {currentLangObj.offers}
                                                    </Link>
                                                    <Link to="#contacts" className="btn btn-primary contact-us">
                                                        {currentLangObj.contactUs}
                                                    </Link>
                                                </div>
                                            </FadeIn>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="texture"></div>
            <div className="diag-bg"></div>
        </section>

  );
}

export default Home;
